import { Instagram, Facebook } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

export const SocialLinks = ({ prefix = "social", className = "" }) => {
  const { settings } = useSettings();
  const items = [
    { key: "instagram", label: "Instagram", Icon: Instagram, url: settings.instagram },
    { key: "facebook", label: "Facebook", Icon: Facebook, url: settings.facebook },
  ].filter((i) => i.url);
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {items.map(({ key, label, Icon, url }) => (
        <a key={key} href={url} target="_blank" rel="noopener noreferrer" aria-label={label}
          data-testid={`${prefix}-${key}-link`}
          className="h-10 w-10 grid place-items-center rounded-full border border-white/10 text-zinc-300 hover:text-emerald-400 hover:border-emerald-500/50 hover:shadow-[0_0_20px_rgba(16,185,129,0.25)] transition-[color,border-color,box-shadow] duration-300">
          <Icon className="h-4 w-4" />
        </a>
      ))}
    </div>
  );
};
